#import "./confluence-comment-fragment.graphql"

query CommentDetails($contentId: ID!, $commentId: ID, $inlineMarkerRef: String) {
  comments(pageId: $contentId, commentId: $commentId, inlineMarkerRef: $inlineMarkerRef) {
    edges {
      cursor
      node {
        ...CommentFragment
        replies {
          ...CommentFragment
        }
        __typename
      }
      __typename
    }
    totalCount
    __typename
  }
}
